export const Setting = {
  googleMapKey: 'AIzaSyBoMwlHxsNalkATrauFKfqqOtpZQCiBiVY',
};
